module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"title":"Supprimer ce lieu d\u0027intérêt ?","subtitle":"{name} sera supprimé définitivement. Cette action est irréversible","btnCancel":"Annuler","btnConfirm":"Supprimer"},"en":{"title":"Delete this POI?","subtitle":"{name} will be deleted permanently. This cannot be undone","btnCancel":"Cancel","btnConfirm":"Delete"}}')
  delete Component.options._Ctor
}
